import payoutsReducer from "./payoutsSlice";
import payoutReducer from "./payoutSlice";

const payouts = {
  payouts: payoutsReducer,
  payout: payoutReducer,
};

export default payouts;
